import { TableHeader } from 'src/app/table-handling';
import { isSpecialHeader } from 'src/app/table-handling/construction/special-headers';

const prefix = 'c:';

export function getTableHeaderIdentifier(header: TableHeader): string {
  if (!header) {
    return '_blank_';
  }
  if (isSpecialHeader(header)) {
    return header.label;
  }
  return `${prefix}${header.column}`;
}
